import React, {useState} from 'react';
import {List, ListItem} from './DownloadDropdown.styles';

type DropdownProps = {
  options: object;
  onSelectItem: object;
  customStyle: object;
};

const DownloadDropdown = React.forwardRef((props: DropdownProps, ref) => {
  const {onSelectItem, customStyle, options} = props;
  const [selected, setSelected] = useState(null);

  const handleItem = idx => {
    setSelected(idx);
    onSelectItem && onSelectItem(idx);
  };

  return (
    <List style={customStyle} ref={ref}>
      {options?.length &&
        options.map((item, index) => (
          <ListItem selected={selected === index} onClick={() => handleItem(index)} key={index}>
            {item}
          </ListItem>
        ))}
    </List>
  );
});

export default DownloadDropdown;
